// Privat-Tab API-Wrapper — Owner-only Endpoints.
//
// Backend: api/src/routes/eve-privat.ts (Doc 2026-05-17).

import { apiFetch } from './api';

export interface LastSeenResponse {
  /** ISO-Timestamp des vorigen Pings — `null` beim allerersten Aufruf. */
  prev_at: string | null;
  current_at: string;
}

export async function pingLastSeen(accessToken: string): Promise<LastSeenResponse> {
  return apiFetch<LastSeenResponse>('/eve/privat/last-seen', { accessToken });
}

// ── Trade-Journal ───────────────────────────────────────────────────────────

export type TradeMood =
  | 'focused'
  | 'tilted'
  | 'fomo'
  | 'disciplined'
  | 'uncertain'
  | 'calm';

export interface TradeJournalEntry {
  id: string;
  symbol: string;
  side: string | null;
  mood: string | null;
  note: string | null;
  created_at: string;
}

export interface TradeJournalListResponse {
  entries: ReadonlyArray<TradeJournalEntry>;
}

export async function listTradeJournal(
  accessToken: string,
  limit = 10,
): Promise<TradeJournalListResponse> {
  return apiFetch<TradeJournalListResponse>(`/eve/privat/trade-journal?limit=${limit}`, {
    accessToken,
  });
}

export interface CreateJournalInput {
  symbol: string;
  side?: string;
  mood?: TradeMood;
  note?: string;
}

export interface CreateJournalResponse {
  ok: true;
  id: string;
  created_at: string;
}

export async function createTradeJournalEntry(
  accessToken: string,
  input: CreateJournalInput,
): Promise<CreateJournalResponse> {
  return apiFetch<CreateJournalResponse>('/eve/privat/trade-journal', {
    method: 'POST',
    accessToken,
    json: input,
  });
}

// ── End-of-Day-Ritual ───────────────────────────────────────────────────────

export type DayMood = 'focused' | 'tilted' | 'satisfied' | 'exhausted' | 'calm';

export interface EndOfDayInput {
  what_worked?: string;
  what_didnt?: string;
  what_open?: string;
  mood?: DayMood;
}

export interface EndOfDayResponse {
  ok: true;
  memory_count: number;
  journal_id: string;
  created_at: string;
}

export async function submitEndOfDay(
  accessToken: string,
  input: EndOfDayInput,
): Promise<EndOfDayResponse> {
  return apiFetch<EndOfDayResponse>('/eve/privat/end-of-day', {
    method: 'POST',
    accessToken,
    json: input,
  });
}
